export const VALID_SKEDULA_HEADERS = {
  Course: 1,
  Section: 1,
  MarkingPeriod: 1,
  Title: 1,
  Department: 1,
  Teacher: 1,
  StudentID: 1,
  LastName: 1,
  FirstName: 1,
  GradeLevel: 1,
  OFC: 1,
  Category: 1,
  CategoryWorth: 1,
  AVG: 1,
};

export const SKEDULA_CSV_COLUMNS = {
  course: 1,
  section: 1,
  markingPeriod: 1,
  title: 1,
  department: 1,
  teacher: 1,
  studentId: 1,
  lastName: 1,
  firstName: 1,
  gradeLevel: 1,
  ofc: 1,
  category: 1,
  categoryWorth: 1,
  avg: 1,
};
